<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div class="form-group" cvModuleCxoneCustomSettingSection after="emp" [moduleManager]="moduleManager">
        <p class="cxone-section-header" cvLocalizedText langSection="Evaluations_Coaching_Module" langKey="Employee_Groups">Employee Groups</p>
        <label cvLocalizedText langSection="Evaluations_Coaching_Module" langKey="Teams">TEAMS</label>
        <cv-group-selector #groupSelectorDTOComp
            *ngIf="settingsManager"
            [showLabels]="false"
            [pageName]="moduleManager.getModuleKey() + '_temp'"
            [baseGroupType]="0"
            [settingsManager]="settingsManager"
            [specificLevel]="2"
            [hasMultiSelect]="true"
            [selectedGroupsDto]="settingsManager.empSelectorDTO"
            (selectedGroupsChanged)="settingsManager.onEmpGroupsChanged($event)"
        ></cv-group-selector>
    </div>
</ng-container>
